import type { UserPermissionValues } from "Infrastructure/Components/PermissionGuard";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";

export const hasPermission = (
	permission: UserPermissionValues | UserPermissionValues[] = [],
	partial?: boolean,
) => {
	const { user } = useUser();

	if (!user?.permissions) return false;

	if (Array.isArray(permission)) {
		if (partial) {
			return permission.some((perm) => user.permissions.includes(perm));
		}
		return permission.every((perm) => user.permissions.includes(perm));
	}

	return user.permissions.includes(permission);
};
